//////////////////////
// import
//////////////////////

import BezierEasing from 'bezier-easing';
import {TweenMax} from "gsap/TweenMax";
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';
import Xt from 'xtend-library';

//////////////////////
// vars
//////////////////////

window.easeIn = new Ease(BezierEasing(1, 0, .64, 1));
window.easeOut = new Ease(BezierEasing(.36, 0, 0, 1));
window.easeInOut = new Ease(BezierEasing(.14, .63, 0, 1));

window.timeTiny = .25;
window.timeSmall = .5;
window.timeMedium = .75;
window.timeBig = 1;
window.timeGiant = 2;

TweenLite.defaultOverwrite = 'all';

//////////////////////
// .btn--menu-mobile
//////////////////////

Xt.observe.push({
  matches: '.btn--menu-mobile',
  fnc: function (main, index, query) {

    // activation

    function eventOn() {
      let top = main.querySelectorAll('rect')[0];
      let bottom = main.querySelectorAll('rect')[1];
      if (main.classList.contains('active')) {
        TweenMax.to(top, window.timeMedium, {x: 3, y: -2, rotationZ: 45, ease: window.easeInOut});
        TweenMax.to(bottom, window.timeMedium, {x: 2, y: 2, rotationZ: -45, ease: window.easeInOut});
      }
    }

    function eventOff() {
      let top = main.querySelectorAll('rect')[0];
      let bottom = main.querySelectorAll('rect')[1];
      if (!main.classList.contains('active')) {
        TweenMax.to(top, window.timeMedium, {x: 0, y: 0, rotationZ: 0, ease: window.easeInOut});
        TweenMax.to(bottom, window.timeMedium, {x: 0, y: 0, rotationZ: 0, ease: window.easeInOut});
      }
    }

    // event

    main.addEventListener('mouseenter', eventOn);
    main.addEventListener('mouseleave', eventOff);
    main.addEventListener('click', eventOff);

    main.addEventListener('on.xt', eventOn);
    main.addEventListener('off.xt', eventOff);

  }
});

//////////////////////
// xtend extension: mask
//////////////////////

/*
window.divRotate = function (outer, inner, angle) {
  let angleCos = Math.abs(Math.cos(angle * Math.PI / 180));
  let angleSin = Math.abs(Math.sin(angle * Math.PI / 180));
  inner.style.width = 'calc(100% * ' + angleCos + ' + 100% * ' + angleSin + ')';
  inner.style.height = 'calc(100% * ' + angleSin + ' + 100% * ' + angleCos + ')';
  outer.style.transform = 'rotate3d(0, 0, 1, ' + angle + 'deg)';
  outer.style.left = -(100 * angleSin) + '%';
  outer.style.top = -(100 * angleSin) + '%';
}
*/

window.fixInitMaskContainer = function(main) {
  // inject

  let mask = main.querySelector('.mask');
  if (!mask) {
    mask = Xt.createElement('<div class="mask"><div></div></div>');
    main.prepend(mask);
    //window.divRotate(mask, mask.firstChild, 15); also remove // disable direction and fill
  }

  // activation

  function eventOn() {
    // mask
    let maskInner = main.querySelectorAll('.mask')[0].firstChild;
    TweenMax.set(maskInner, {opacity: 0, yPercent: '100%'});
    TweenMax.to(maskInner, window.timeMedium, {opacity: .1, yPercent: '0%', ease: window.easeInOut});
    // img
    let images = main.querySelectorAll('.mask_img');
    for (let image of images) {
      TweenMax.to(image, window.timeMedium, {scale: 1.05, ease: window.easeOut});
    }
    // content
    let contents = main.querySelectorAll('.mask_content');
    for (let content of contents) {
      TweenMax.set(content, {y: 5});
      TweenMax.to(content, window.timeMedium, {opacity: 1, y: 0, ease: window.easeInOut})
        .delay(window.timeTiny);
    }
  }

  function eventOff() {
    if (!main.classList.contains('active')) {
      // mask
      let maskInner = main.querySelectorAll('.mask')[0].firstChild;
      TweenMax.to(maskInner, window.timeMedium, {opacity: 0, yPercent: '-100%', ease: window.easeInOut});
      // img
      let images = main.querySelectorAll('.mask_img');
      for (let image of images) {
        TweenMax.to(image, window.timeMedium, {scale: 1, ease: window.easeOut});
      }
      // content
      let contents = main.querySelectorAll('.mask_content');
      for (let content of contents) {
        TweenMax.to(content, window.timeMedium, {opacity: 0, y: 5, ease: window.easeInOut});
      }
    }
  }

  // event

  main.addEventListener('mouseenter', eventOn);
  main.addEventListener('mouseleave', eventOff);
  main.addEventListener('click', eventOff);

};

Xt.observe.push({
  matches: '.mask_container',
  fnc: function (main, index, query) {

    window.fixInitMaskContainer(main);

  }
});

//////////////////////
// sticky header
//////////////////////

Xt.observe.push({
  matches: '[data-js-sticky]',
  fnc: function (main, index, query) {
    // vars

    const object = main;
    let self

    // reinit

    const reinit = function() {
      if (self) {
        object.classList.remove('sticky--hide');
        object.style.transform = 'translateY(0px)';
      } else {
        self = new Xt.Sticky(object, {
          "sticky": "fixed",
          "limit": {"top": ".header.xt-clone .header--limit-top"},
          "hide": "down"
        });
      }
    }

    reinit();
    document.querySelector('body').addEventListener('replace.xt.infinitescroll', reinit);
    document.querySelector('body').addEventListener('off.xt', reinit);
  }
});

//////////////////////
// sticky filters
//////////////////////

Xt.observe.push({
  matches: '[data-js-sticky-filters]',
  fnc: function (main, index, query) {
    // vars

    const object = main;
    
    // sticky

    new Xt.Sticky(object, {
      "limit": {"top": "[data-js-sticky-filters-limit-top]"},
    });
  }
});

